export default {
  init() {
    // JavaScript to be fired on all pages

    //related products slick
    $('.related-products .products-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      arrows: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 431,
          settings: 'unslick',
        },
      ],
    });

    $( '.variations_form' ).on( 'found_variation', function (  ) {
      $('.title-price-container .starting-price-container').hide();
    } );
    
    $( '.variations_form' ).on( 'reset_data', function (  ) {
      $('.title-price-container .starting-price-container').show();
    } );
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // handle thumbnail clicks
    initGallery();
    function initGallery(){
      var productThumbsWrap = $('.woocommerce-product-gallery .product-thumbs-wrap');

      productThumbsWrap.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        centerMode: true,
        centerPadding: '0px',
        infinite: true,
        responsive: [
          {
            breakpoint: 479,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              vertical: false,
              verticalSwiping: false,
              arrows: false,
              centerMode: false,
            },
          },
        ],
      });
      
      $('.woocommerce-product-gallery .product-thumbs-wrap .woocommerce-product-gallery__image a').on('click', function(e) {
        e.preventDefault();

        var imageWrap = $('.woocommerce-product-gallery__wrapper > .main-image-wrap > .woocommerce-product-gallery__image');
        imageWrap.find('.video-embed').remove();

        // handle video case
        var video = $(this).parent().data('video');

        if(video !== undefined) {
          imageWrap.append('<div class="video-embed"><iframe width="100%" height="400" src="https://www.youtube.com/embed/'+video+'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>');
          imageWrap.find('a .wp-post-image').hide();
          imageWrap.find('.zoomImg').hide();
        } else {
          // we have no video, this is a normal image
          imageWrap.find('a .wp-post-image').show();
          imageWrap.find('.zoomImg').show();

          var fullsize = $(this).find('img').data('src');

          imageWrap.find('img').attr('src',fullsize);
          imageWrap.find('img').attr('srcset',fullsize);

          var tmpImg = new Image();
          var orgWidth = '';
          var orgHeight = '';
          tmpImg.src = fullsize; //or  document.images[i].src;

          $(tmpImg).one('load',function(){
            orgWidth = tmpImg.width;
            orgHeight = tmpImg.height;

            $('.zoomImg').load(function() {
                jQuery('.zoomImg').css('width',orgWidth+'px');
                jQuery('.zoomImg').css('height',orgHeight+'px');
            }).attr('src',fullsize);


            jQuery('.zoomImg').prev().attr('href', fullsize);
            var largeImage = jQuery('.zoomImg').prev().find('img');
            largeImage.attr('src', fullsize).data('src', fullsize).data('large_image', fullsize).data('large_image_width', orgWidth).data('large_image_height',orgHeight);
            largeImage.attr('srcset', '');
          });

          //scroll to slide
          var index = $(this).parent().data('slick-index');
          if ((productThumbsWrap.slick('slickCurrentSlide') !== index)) {
            productThumbsWrap.slick('slickGoTo', index);
          }
        }

        return false;
      });

      productThumbsWrap.find('.woocommerce-product-gallery__image a').first().trigger('click');

      $('.main-image-wrap .woocommerce-product-gallery__image a').click(function(e){
        $('.woocommerce-product-gallery__trigger').trigger('click');

        e.preventDefault();
        e.stopPropagation();
      });

      $('.main-image-wrap .woocommerce-product-gallery__image').click(function(){
        $('.woocommerce-product-gallery__trigger').trigger('click');
      });

      $('.woocommerce-product-gallery__wrapper .main-image-wrap .gallery-arrow-right').click(function(){  
        // var slideCount = productThumbsWrap.slick('getSlick').slideCount;
        var currentIndex = productThumbsWrap.slick('slickCurrentSlide');
        // if(slideCount > 4){
        //   productThumbsWrap.slick('slickNext');
        // }
        $('.woocommerce-product-gallery .product-thumbs-wrap .slick-slide[data-slick-index="'+(currentIndex+1)+'"] a').trigger('click');
      });

      $('.woocommerce-product-gallery__wrapper .main-image-wrap .gallery-arrow-left').click(function(){        
        // var slideCount = productThumbsWrap.slick('getSlick').slideCount;
        var currentIndex = productThumbsWrap.slick('slickCurrentSlide');
        // if(slideCount > 4){
        //   productThumbsWrap.slick('slickPrev');
        // }
        $('.woocommerce-product-gallery .product-thumbs-wrap .slick-slide[data-slick-index="'+(currentIndex-1)+'"] a').trigger('click');
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js